import './styles/PushNotificationCard.scss';

import { Alert, Grid, Paper, Switch, Typography } from '@mui/material';

import { useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';

import PushNotificationLogo from 'assets/handy-pushnotification.svg';
import { translations } from 'locales/i18n';

export const PushNotificationCard = () => {
  const { t } = useTranslation();
  const { values, setFieldValue } = useFormikContext<{
    isPushNotificationEnabled: boolean;
    id: string | number;
  }>();
  return (
    <>
      <Grid container elevation={2} className="pushNotificationCard" component={Paper} square>
        <Grid item xs={4}>
          <Grid container gap={2}>
            <Grid item md={2} className="logo">
              <img
                src={PushNotificationLogo}
                width={64}
                height={64}
                alt="pushnotification-mobile-with-exclamation-mark"
              />
            </Grid>
            <Grid item md={2} className="pushToggleContainer">
              <Switch
                name="isPushNotificationEnabled"
                className="pushToggle"
                disabled={!!values.id}
                checked={values.isPushNotificationEnabled}
                onChange={v => {
                  setFieldValue('isPushNotificationEnabled', v.target.checked);
                }}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={8}>
          <Grid container className="" gap={2}>
            <Typography variant="subtitle2">
              {t(translations.pages.articles.create.preview.pushNotificationDescription())}
            </Typography>
            <Alert severity="info">
              {t(translations.pages.articles.create.preview.pushNotificationAlert())}
            </Alert>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};
